import { IBuilderOptions } from "./builder-models";
import { simpleClone } from "../common/common-service-utils";

//   Legacy options missing need adding
//   The problem with merge is that it will overwrite the existing values
//   with potentially garbage values.
export function cleanServerResponse(
  builderOptions: IBuilderOptions
): IBuilderOptions {
  const builderOptionsInternal: IBuilderOptions = simpleClone(builderOptions);

  if (!builderOptionsInternal.autoEntries) {
    builderOptionsInternal.autoEntries = {
      selectedTargetComp: {
        id: 0,
        name: "",
        timeTronicsUrl: "",
      },
      targetable: {
        allowedSources: [],
        enabled: false,
      },
    };
  }
  if (!builderOptionsInternal.level) {
    builderOptionsInternal.level = "";
  }
  if (builderOptionsInternal.pbMandatory === undefined) {
    builderOptionsInternal.pbMandatory = false;
  }
  if (builderOptionsInternal.pbMandatory === undefined) {
    builderOptionsInternal.pbMandatory = false;
  }
  if (!builderOptionsInternal.cloneInfo) {
    builderOptionsInternal.cloneInfo = {
      fromId: 0,
    };
  }

  if (!builderOptionsInternal.flyerInfo) {
    builderOptionsInternal.flyerInfo = "";
  }
  if (!builderOptionsInternal.timetable) {
    builderOptionsInternal.timetable = "provisional";
  }

  if (!builderOptionsInternal.allowAdd) {
    builderOptionsInternal.allowAdd = {
      unregistered: false,
      registered: true,
      international: false,
    };
  }

  if (!builderOptionsInternal.simpleRegistration) {
    builderOptionsInternal.simpleRegistration = {
      enabled: false,
      ui: {
        showClub: false,
        showSchool: false,
      },
    };
  }

  //  Coming up sometimes as a number, sometimes as a string
  const paymentCode: string | number = builderOptionsInternal.paymentCode as
    | string
    | number;

  //  sometimes not present
  if (!builderOptionsInternal.paymentCode) {
    builderOptionsInternal.paymentCode = "";
  }

  if (typeof paymentCode === "number") {
    builderOptionsInternal.paymentCode = paymentCode.toString();
  }

  const bibNos: string | number = builderOptionsInternal.bibNos as
    | string
    | number;
  if (typeof bibNos === "number") {
    builderOptionsInternal.bibNos = builderOptionsInternal.bibNos.toString();
  }

  const contactTel: string | number = builderOptionsInternal.contact.tel as
    | string
    | number;
  if (typeof contactTel === "number") {
    builderOptionsInternal.contact.tel = contactTel.toString();
  }

  if (!builderOptionsInternal.helpText.athletes) {
    builderOptionsInternal.helpText.athletes = "";
  }

  if (typeof builderOptionsInternal.useV2Routes === undefined) {
    builderOptionsInternal.useV2Routes = true;
  }

  // add useNewResults if not present
  if (builderOptionsInternal.useNewResults === undefined) {
    builderOptionsInternal.useNewResults = false;
  }

  return builderOptionsInternal;
}
